module.exports = __webpack_public_path__ + "img/aqmola1.9a8d049f.jpg";